import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import history from '../history';
import i18n, { translationService } from './index';

export const subscribeTranslationSync = (navigation, service, target = window) => {
    const handleLocation = location => {
        if (location.pathname === '/') {
            const params = new URLSearchParams(location.search);
            // The backend can infer the client from the delegated token.
            void service.start({ token: params.get('delegatedToken'), lang: params.get('lang') });
        } else {
            void service.refresh();
        }
    };
    handleLocation(navigation.location);
    const unlisten = navigation.listen(handleLocation);
    const onFocus = () => { void service.refresh(); };
    target.addEventListener('focus', onFocus);
    return () => {
        unlisten();
        target.removeEventListener('focus', onFocus);
    };
};

const TranslationProvider = ({ children }) => {
    useEffect(() => subscribeTranslationSync(history, translationService), []);
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default TranslationProvider;
